import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import './Header.scss';
import { FaBars } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import Images from '../../Assets/Images/Images';

const Header = ({ setShowNav }) => {
  return (
    <div className='header'>
      <Container>
        <Row>
          <Col xs={10}>
            <NavLink to='/' className='header__logo-link'>
              <img alt='house-of-arie' className='header__logo' src={Images.logo} />
            </NavLink>
          </Col>
          <Col className='d-flex justify-content-end align-content-center'>
            <button
              className='header__bars'
              onClick={() => setShowNav(true)}
            >
              <FaBars size={'1.5em'} />
            </button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Header;
